
import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { SettingGrid } from "./gridSettings/gridSettings";
/*

{
    "id": 0,
    "idDestinatario": 0,
    "idMagazzino": 0,
    "idTipoCarico": "string",
    "cer": "string",
    "riferimentoCER": "string",
    "idStatoFisico": "string",
    "pesoKg": 0,
    "volumeMC": 0,
    "protocollo": "string"
  }


*/
// Per form filtro in editgiacenzainiziale

const settingGridGeneric: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px'
    },
  ],

}

export const GiacenzeRifiutiFiltro: AnaColumn[] = [
  {
    itemType: "group", groupDataField: 'giacenzeFiltro', colCount: "2", caption: "Giacenze Iniziali",
    data: [
      {
        type: 'campoSpecial', colVisible: true, hideOnEdit: false, disableOnUpdate: false,
        caption: 'Unita Locale', width: '20vw',
        dataField: "idDestinatario",
        editorType: 'dxSelectBox',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],

        lista: {
          selectFirstElement: false,
          dataSource: "Sede/GetSediNsAziende", valueExpr: 'id',
          displayExpr: 'descrizioneSede',
          showClearButton: false,
          cascading: ['idDestinatario|idMagazzino', 'idDestinatario|idCantiereFuoriUl']
        }
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idMagazzino",
        caption: 'Magazzino', width: '21vw',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lista: {
          selectFirstElement: false,
          dataSource: "magazzinorifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '?idSede=$idDestinatario',
          showClearButton: false,
          // showSelectionControls:false,        
        }
      },
      {
        type: 'campoSpecial', colVisible: true,

        editorType: 'dxSelectBox',
        dataField: "idPosizioneRifiuto",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        caption: 'Posizione', width: '20vw',
        lista: {
          selectFirstElement: false,
          dataSource: "PosizioneRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
          //showSelectionControls:true,      
        }
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idCantiereFuoriUl",
        disableOnUpdate: false,
        width: '21vw',
        caption: 'Cantiere',
        lista: {
          dataSource: "Cantiere",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '/$idDestinatario',
          showClearButton: false,
        }
      },
      /*
      { type: 'empty', dataType: '', dataField: 'NoType', caption: '', class: '', },
      {
          type: 'simpleButton', dataField: "buttonElabora",
          colVisible: false, class: 'text-start text-left ms-5 blueButton', editorClass: 'ms-5',
          button: {
            text: 'Elabora',
            name: "elaboraFiltro",
            event: "elaboraFiltro",
            type: "normal",
            hint: "Elabora",
            icon: "glyphicon fa fa-bolt",
            class:'blueButton',
          }
        },
      */



    ]
  }
]

export const GiacenzeRifiuti: AnaColumn[] = [
  {
    itemType: "group", groupDataField: 'giacenzeStatistica', colCount: "4", caption: "",
    data: [
      {
        type: 'campoSpecial', colVisible: true, hideOnEdit: false, disableOnUpdate: false,
        caption: 'Unita Locale',
        width: '22vw',
        dataField: "idDestinatario",
        editorType: 'dxSelectBox',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],

        lista: {
          selectFirstElement: true,
          dataSource: "Sede/GetSediNsAziende", valueExpr: 'id',
          displayExpr: 'descrizioneSede',
          showClearButton: false,
          cascading: ['idDestinatario|idMagazzino', 'idDestinatario|idCantiere'],
          related: ['idDestinatario|idMagazzino', 'idDestinatario|idCantiere']
        }
      },
      {
        type: 'campoSpecial', colVisible: true,

        editorType: 'dxTagBox',
        dataField: "idPosizioneRifiuto",
        caption: 'Posizione', width: '22vw',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        tagBoxList: {
          maxDisplayedTags: 2,
          dataSource: "PosizioneRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
          showSelectionControls: true,
        }
      },
      { type: 'empty', dataType: '', dataField: 'NoType', caption: '', class: '', },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxTagBox',
        dataField: "idMagazzino",
        caption: 'Magazzino', width: '22vw',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        tagBoxList: {
          dataSource: "magazzinorifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '?idSede=$idDestinatario',
          showClearButton: true,
          showSelectionControls: true,
          maxDisplayedTags: 2,
        }
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxTagBox',
        dataField: "idCantiere",
        disableOnUpdate: true,
        width: '22vw',
        caption: 'Cantiere',
        tagBoxList: {
          maxDisplayedTags: 2,
          dataSource: "Cantiere",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '/$idDestinatario',
          showClearButton: true,
          showSelectionControls: true,
        }
      },
      {
        type: 'campo',

        dataField: "isEscludiCantieriFouriUl",
        dataType: 'boolean',
        caption: "Escludi Cantieri",
        editorType: "dxCheckBox",
        colVisible: false,
        width: '6vw',
        showClearButton: false,
        //defaultValue:false
      },
      //{ type: 'empty', dataType: '', dataField: 'NoType', caption: '', class: '', },

      {
        type: 'campoData',
        dataField: "analisiData",
        caption: "Alla data",
        format: "dd/MM/yyyy",
        mask: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        width: '8vw',
        maxLength: '15',
        colVisible: false,
        showClearButton: false,
        defaultValue: 'now'
      },
      {
        type: 'campo',
        dataField: "DettagliaRiferimenti",
        caption: "Dettaglia Riferimenti",
        editorType: "dxCheckBox",
        colVisible: false,
        width: '8vw',
        dataType: 'boolean',
        class: 'padding-left-4',
        showClearButton: false,
        //defaultValue:true
      },
      /* {
         type: 'simpleButton', dataField: "buttonInsertGiacenza",
         colVisible: false, class: 'text-start text-left ms-5 blueButton', editorClass: 'ms-5',
         button: {
           text: 'Inserisci Giacenza',
           name: "inserisciGiacenza",
           event: "inserisciGiacenza",
           type: "normal",
           hint: "Inserisci Giacenza",
           icon: "glyphicon fa fa-bolt",
           class:'blueButton',
         }
       },*/
      /*{
        type: 'simpleButton', dataField: "buttonElaboraGiacenza",
        colVisible: false, class: 'text-start text-left ms-5 blueButton', editorClass: 'ms-5',
        button: {
          text: 'Elabora Giacenze',
          name: "elaboraGiacenze",
          event: "elaboraGiacenza",
          type: "normal",
          hint: "Elabora Giacenze",
          icon: "glyphicon fa fa-bolt",
          class:'blueButton',
        }
      }*/
    ]
  }
]

// nica form edit/insert
export const GiacenzeIniziali: AnaColumn[] = [
  {

    configuration:
    {
      titleGriglia: 'Giacenze',
      //titleForm: '$descrizioneSoggetto',
      //breadcrumbCaption: 'Anagrafica azienda',
      //campoTitle: ['descrizioneSoggetto'],
      masterKey: 'id',
      service: 'GiacenzaRifiutiIniziali',
      api: 'GiacenzaRifiutiIniziali',
      filterEditor: '/$id',
      formType: 'simple',
      nCol: 1,

    },


  },
  //
  {
    itemType: "group", colCount: "3", groupDataField: 'giacenze', caption: "Tipologia Giacenza", class: "mt-2",
    data: [

      {
        type: 'campoSpecial', colVisible: true, hideOnEdit: false,
        disableOnUpdate: true,
        caption: 'Unita Locale', width: '25vw',
        dataField: "idDestinatario",
        editorType: 'dxSelectBox',

        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lista: {
          dataSource: "Sede/GetSediNsAziende", valueExpr: 'id',
          displayExpr: 'descrizioneSede',
          showClearButton: false,
          cascading: ['idDestinatario|idMagazzino', 'idDestinatario|idCantiereFuoriUl']
        }
      },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },
      // { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idMagazzino",
        disableOnUpdate: true,
        caption: 'Magazzino', width: '15vw',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lista: {

          dataSource: "magazzinorifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '?idSede=$idDestinatario',
          showClearButton: false,
        }
      },
      {
        type: 'campoSpecial', colVisible: true,
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        editorType: 'dxSelectBox',
        dataField: "idPosizioneRifiuto",
        disableOnUpdate: true,
        caption: 'Posizione',
        width: '10vw',
        lista: {
          dataSource: "PosizioneRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
        }
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idCantiereFuoriUl",
        disableOnUpdate: true,
        width: '11.2vw',
        caption: 'Cantiere',
        lista: {
          placeholder: "",
          dataSource: "Cantiere",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '/$idDestinatario',
          showClearButton: false,
        }
      },
      //{ type: 'empty', dataType: '', dataField: 'NoType', caption: '', class: '', },

      //------------------------
      {
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '110',
        orderGriglia: 7,
        width: '6.6vw',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        showClearButton: false,
        dynamic: {
          valueExpr: 'id',
          queryString: "?$filter=not endswith(id,'00')",
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['descrizione|descrizioneCer', 'pericoloso|pericoloso'],

          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia elenco dei rifiuti eer',
            name: 'eer',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            mode: null,
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            isOdata: true,
            height: 630,
            showColBlank: false,
          },
        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],
      },





      /*{
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '110',
        orderGriglia: 7,
        maxLength: '6',
        width: 115 + 'px',
        caption: "EER1",  
        
        //disableOnUpdate:true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          //filterStatic: "?$filter=not endswith(id,'00')",
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista EER",
          componentType: 'grid',
          related: ['descrizione|descrizioneCer', 'pericoloso|pericoloso'],
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
      
        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ]
      },*/
      {
        type: 'campo', dataField: "pericoloso", dataType: "", caption: "",
        width: 1 + 'vw',
        colVisible: false,
        labelVisible: false,
        editorType: 'dxCheckBox',
        class: 'cer-pericoloso',
        defaultValue: false,
        disabled: true,
        disableOnUpdate: true
      },
      {
        //Era campo special. se metti campo special e non indichi nulla le options all'items non vengono aggiunge, tra cui la larghezza, 
        //quindi se non  deve fare nulla ma solo descrivere il nome del cer mettiamolo come campo normale o campo descrittvvo campoDesc

        type: 'campo', dataField: "descrizioneCer", dataType: "",
        colVisible: false,
        labelVisible: false,
        readonly: true,
        width: '44.2vw',//515 + 'px',  
        placeHolder: '',
        /*dynamic: {
          queryString: '',
          displayExpr: 'descrizione',
          filterStatic: "?$filter=not endswith(id,'00')",
          dataSource: 'cer',
          service: 'cer',    
          autocomplete: false,
          checkValue: { 
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          caption: "Lista EER",
          componentType: 'grid',
          related: ['id|eer', 'pericoloso|pericoloso'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'EER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista EER',
            name: 'Cer',
            location: 'after',
          },
          buttons: [
            {
              class: 'badge',
              name: 'addSchedaTecnica',
              accesskey: 's',
              location: 'after',
              event: "SchedarifiutiComponent",
              hint: "Incolla dati rifiuto dalla scheda tecnica (F12)",
              icon: "glyphicon icon-elenco-cer-trasp",
              outPutValue: false,
            },
            {
              name: 'GiacenzeRifiuti',
              icon: 'glyphicon icon-giacenze-magazzino',
              hint: 'Giacenze rifiuti',
              location: 'after',
              event: 'StatisticarifiutiComponent',
              visible: true
      
      
            },
          ]
        },*/




      },


      {
        type: 'campo', dataField: "riferimentoEER", dataType: "",
        caption: "Riferimento",
        width: 215 + 'px',
        colVisible: true,
        labelVisible: true,
        maxLength: '10',
      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",
        width: 3 + 'vw',
        colVisible: false,
        labelVisible: true,
        orderGriglia: 9,
        class: 'stato-fisico me-2Os',
        showClearButton: false,
        maxLength: '2',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          related: ['descrizione|descrizioneStatoFisico'],
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric

        },
      },
      { type: 'campo', readonly: true, labelVisible: false, width: '29.4vW', dataType: '', dataField: 'descrizioneStatoFisico', caption: '', class: 'ms-2', },

      /*{type: 'campoSpecial', colVisible: true,
      validation: [{ type: "required", message: "Campo Obbligatorio" },],
      editorType:'dxSelectBox', 
      dataField: "idStatoFisico",
      caption:'Stato Fisico',width:'10vw',
      lista: {
        dataSource: "StatoFisico", 
        valueExpr: 'id', displayExpr: 'descrizione',
       // queryString:'?idSede=$idDestinatario',
        showClearButton: false,        
      } 
      },*/

      /*{
          type: 'campoSpecial', colVisible: true,    
          disableOnUpdate:false,
          editorType:'dxSelectBox', 
          dataField: "idTipoCarico",
          caption:'Tipo Carico',width:'15vw',
          lista: {
            dataSource: "TipoCarico", 
            valueExpr: 'id', displayExpr: 'descrizione',
            // queryString:'?idSede=$idDestinatario',
            showClearButton: false,        
          } 
      },*/

      {
        type: 'campoSpecial',
        editorType: 'dxTagBox',
        dataField: "listaHP", caption: "Carat. pericolo",
        dataType: "",
        width: '370px',
        hideOnEdit: false,

        tagBoxList: {
          dataSource: 'Hp',
          displayExpr: 'id',
          valueExpr: 'id',
          maxDisplayedTags: 5,
          multiline: false,
          showSelectionControls: true,
        }

      },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },

      {
        type: 'campoSpecial', colVisible: true,
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        editorType: 'dxSelectBox',
        dataField: "idProvenienzaGiacenza",
        caption: 'Provenienza', width: '24.8vw',
        lista: {
          dataSource: "ProvenienzaGiacenza",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
        }
      },

      {
        type: 'campo', dataField: "quantitaKg", dataType: "", caption: "Quantita (Kg)",
        format: environment.PRECISION,
        maxLength: "11",
        colVisible: false,
        labelVisible: true,
        editorType: 'dxNumberBox',
        defaultValue: 0,
        validation: [{ type: "range", message: "Campo Obbligatorio", min: '1', max: '999999' },],
      },
      {

        type: 'campo', dataField: "quantitaMc", dataType: "", caption: "Quantita in MC",
        format: environment.PRECISION,
        maxLength: "11",
        defaultValue: 0,
        colVisible: false,
        labelVisible: true,
        editorType: 'dxNumberBox',
      },

      /*{
        type: 'simpleButton', dataField: "buttonDettagli",
        colVisible: false, visible:false, class: 'text-start text-left ms-5 blueButton', editorClass: 'ms-5',
        button: {
          text: 'Dettagli',
          name: "Dettagli",
          event: "dettagli",
          type: "normal",
          hint: "Carica dettagli giacenza",
          //icon: "mdi mdi-google-maps",
          icon: 'glyphicon icon-giacenze-magazzino',
          class:'blueButton'
          //related: ['latidudine', 'longitudine'],
        }
      },*/
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },
      { type: 'empty', dataType: '', dataField: '', caption: '', class: '', },
      //----------



      /* {
         type:'button',colSpan:"2",
         button:{
           hint:'Relazioni di carico',
           name:'addProtocolli',
           text:'Relazioni di carico',
           icon:'link'
         }
       },*/
    ]
  },
  {
    itemType: "group", colCount: '1', colSpan: '1', caption: "Dettaglio elenco protocolli di carico", class: "dettaglio-elenco",
    data: [
      {
        showInColumnChooser: false,
        type: 'campoComponent', labelVisible: false,
        colSpan: "1", dataField: 'listGiacenzaRifiutiInizialiDettagli',
        colAlignment: 'center',
        colVisible: false,
        width: 1300,
        class: 'mx-5 dettaglio-elenco',


        /**Tipo Dynamico ma apre componente Griglia non in popup*/

        dynamic: {

          dataSource: '',
          service: 'DettagliGiacenzeIniziali',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          //caption: "Lista Magazzino EER",
          componentType: 'dynamicGrid',

          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'anno',
            keyUnique: '',
            mode: 'row',
            remoteOperations: false, //Abilitato per il salvataggio edit e delete
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 270,
            showFilterSearch: false,
            showColBlank: false,
            desButtonAdd: 'Aggiungi Riferimento',
            columnAutoWidth: false,
          }

        }


      },
    ]
  }
]
export const GiacenzeInizialiGrid: AnaColumn[] = [
  {
    itemType: "group", colCount: "12", caption: "Giacenze Iniziale",
    data: [
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "id" },
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "idDestinatario" },
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "idMagazzino" },
      { type: 'campo', colVisible: false, hideOnEdit: true, disableOnUpdate: true, dataField: "idPosizioneRifiuto" },

      /* {
         type:'button',colSpan:"2",
         button:{
           hint:'Relazioni di carico',
           name:'addProtocolli',
           text:'Relazioni di carico',
           icon:'link'
         }
       },*/


      {
        type: 'campo', colVisible: true, caption: 'Cod. EER', disabled: true, dataField: "eer", colSpan: "3",
        editorType: "",
      },
      {
        colVisible: false,
        disableOnUpdate: true,
        colWidth: '100',
        type: 'campo', colSpan: "9", caption: "Descrizione EER", dataField: "eer", dataType: "",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        lookup: {
          wingap: true,
          dataSource: "cer?$orderby=Descrizione&$filter=(not endswith(id,'00'))",
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: true,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        disableOnUpdate: true,
        type: 'campo', maxLength: '15', colSpan: "3", dataField: "riferimentoEER", dataType: "", caption: "Riferimento",
      },
      {
        type: 'campoSpecial', colVisible: true,
        editorType: 'dxSelectBox',
        dataField: "idRegistro",
        caption: 'Registro',
        width: 12 + 'vw',
        placeHolder: '',
        lista: {
          dataSource: "RegistroRifiuti",
          valueExpr: 'id', displayExpr: 'descrizione',
          queryString: '?$filter=(idSede eq $idDestinatario)',
          filter: '?$filter=(idSede eq $idDestinatario)',
          costantValues: [
            { key: 'idSede', value: 'idDesinatario' }
          ],
          showClearButton: false,
        }
      },
      /*{
        type: 'empty', colSpan: "4"
      },*/
      {
        disableOnUpdate: true,
        type: 'campo', width: '250px', colSpan: "6", dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],

        lookup: {
          wingap: true,
          caption: 'Stato Fisico',
          dataSource: 'StatoFisico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        disableOnUpdate: true, colVisible: false,
        type: 'campo', width: '250px', colSpan: "6", dataField: "idTipoCarico", dataType: "", caption: "Tipo Carico",
        placeHolder: '',
        validation: [{ type: "required", message: "Campo Obbligatorio" },],

        lookup: {
          wingap: true,
          caption: 'Tipo Carico',
          dataSource: 'tipoCarico',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        disableOnUpdate: true,
        type: 'campo', width: '250px', colSpan: "6", dataField: "idProvenienzaGiacenza", dataType: "", caption: "Provenienza",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],

        lookup: {
          wingap: true,
          caption: 'Provenienza',
          dataSource: 'ProvenienzaGiacenza',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice'
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
            }
          ]
        }
      },
      {
        type: 'empty', colSpan: "6"
      },
      {
        type: 'number', colVisible: true, colSpan: "3",

        //tipoTotale:'sum',
        /*dxoSummary:{  
          summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "quantitaKg", dataType: "number",
        validation: [{ type: "required", message: "Campo Obbligatorio" },],
        caption: "Quantita (Kg)", maxLength: "10",
        tipoTotale: 'sum',
        colAlignment: 'right',
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: true,
          alignByColumn: true,
          valueFormat: environment.PRECISION,
          displayFormat: "Totale: {0}",
          alignment: 'right'
        },
        format: environment.PRECISION,


      },
      /*{
        type: 'empty', colSpan: "8"
      },*/
      {

        type: 'number', colVisible: true, colSpan: "3",
        /*tipoTotale:'sum',
        dxoSummary:{  summaryType:'sum',
          showInGroupFooter:false,
          alignByColumn:true,
          valueFormat:"fixedPoint",
          displayFormat:"Totale: {0}"
        },*/
        editorType: "dxNumberBox", dataField: "quantitaMc", dataType: "",
        caption: "Volume", format: '000000.###', maxLength: "10"
      },
      {
        type: 'empty', colSpan: "6"
      },
      /* {        
         type: 'campo', maxLength: '10', colSpan: "3", dataField: "protocollo", dataType: "", caption: "N.Protocollo",
         helpText:'Il campo deve terminare con /YYYY es. Prot. 256/2020'
       },*/
      /*{        
        type: 'campo', maxLength: '10', colSpan: "4", dataField: "anno_protocollo", dataType: "", caption: "Anno",
        helpText:'Il campo deve terminare con /YYYY es. Prot. 256/2020'
      },*/
    ]
  },
]
export const ListaMovimentiGiacenza: AnaColumn[] = [
  {
    itemType: "group", colCount: "12", caption: "Giacenze Iniziale",
    data: [
      /*{
        type:'button',
        orderGriglia: 1,
        button:{
          hint:'Dettagli Movimento',
          name:'DettagliMovimento',
          text:'Dettagli Movimento',
          icon:'link'
        }
      },*/
      {
        type: 'campo', dataField: "causale_Descrizione", dataType: "", caption: "Causale Operazione",
        colVisible: true,
        hideOnEdit: true,
        allowFiltering: false,
        orderGriglia: 3

      },
      {
        allowFiltering: false,
        type: 'campoData',
        dataType: 'date',
        dataField: 'dataRegistrazione',
        caption: 'Data reg.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        colWidth: '100',
        orderGriglia: 4,

        showClearButton: false,
      },
      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.FIR',
        maxLength: '20', maxSize: 20, colWidth: '100',
        width: '5.4vw', class: 'num-fir',
        allowFiltering: false,

      },
      {
        allowFiltering: false,
        type: 'campoData', dataType: 'date', dataField: 'dataFormulario',
        caption: 'Data FIR',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        class: 'data-doc-fir',
        colWidth: '100',
        showClearButton: false,
        colVisible: true,
        width: '145px',

      },
      {
        type: 'campoSpecial', colVisible: true,
        disableOnUpdate: false,
        editorType: 'dxSelectBox',
        dataField: "idTipoCarico",
        //autoWidth:false,
        allowFiltering: true,
        caption: 'Modalità',
        lista: {

          dataSource: "TipoCarico",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
        }
      },
      /*{
        type: 'campo', dataField: "idTipoCarico", dataType: "", caption: "Modalità",
        colVisible: true,
        hideOnEdit: true,        
      },*/
      {
        type: 'campo', dataField: "idOperazioneRD", dataType: "", caption: "Op.",
        colVisible: true,
        hideOnEdit: true, colWidth: '50px',
        allowFiltering: false,
      },
      /*
      {
        type: 'campo', dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",
        colVisible: true,
        hideOnEdit: true,
      },*/
      /*{
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Riferimento",
        colVisible: true,
        hideOnEdit: true,
      },*/
      {
        type: 'campo', dataField: "giacenzaIniziale", dataType: "",
        caption: 'Giacenza Iniziale',
        colVisible: true,
        format: environment.PRECISION,
        colWidth: '120',
        labelVisible: true,
        editorType: 'dxNumberBox',
        colAlignment: 'right',
        allowFiltering: false,

      },
      {
        type: 'campo', dataField: "carico", dataType: "",
        caption: 'Carico',
        colVisible: true,
        format: environment.PRECISION,
        colWidth: '120px',
        labelVisible: true,
        editorType: 'dxNumberBox',
        colAlignment: 'right',
        allowFiltering: false,

      },

      {
        type: 'campo', dataField: "scaricoInterno", dataType: "",
        format: environment.PRECISION,
        caption: 'Scarico Interno',
        colAlignment: 'right',
        colVisible: true,
        colWidth: '120px',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        allowFiltering: false,

      },
      {
        type: 'campo', dataField: "scaricoATerzi", dataType: "",
        format: environment.PRECISION,
        caption: 'Scarico a Terzi',
        colVisible: true,
        colWidth: '120px',
        colAlignment: 'right',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        allowFiltering: false,

      },
      {
        type: 'campo', dataField: "giacenzaFinale", dataType: "",
        format: environment.PRECISION,
        caption: 'Prg. Giacenza',
        colVisible: true,
        colWidth: '120px',
        labelVisible: true,
        colAlignment: 'right',
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        allowFiltering: false,

      }]
  }
]

